
/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import React from 'react';
//structure
import SubPage from 'material/structure/subpage/subpage';
//copy
import Copy from 'material/copy/copy';
import Title from 'material/copy/title/title';
import BodyCopy from 'material/copy/bodycopy/bodycopy';
//CTAs
import CTAs from 'material/ctas/ctas';
import Button from 'material/ctas/button/button_container';
// styles
import injectSheet from 'react-jss';
import styles from 'material/message/popup/popup_styles';



/* ========== ~~~~~~~~~~ MODALMESSAGE : MODAL ~~~~~~~~~~ ========== */
// PRESENTATIONAL COMPONENT
// receives app state & actions as props from parent "_container" component
// also receives two call back functions to route user
// this child component handles local state and uses props passed from parent to read/write application state when necessary
const PopupMessage = (props) => (
    <SubPage name={`popupmessage type-${props.type}`} klass={props.classes.popupmessage}>
        <Copy>
            <Title>
                {!!props.title && <h5>{props.title}</h5>}
            </Title>
            {!!props.body && <BodyCopy>{props.body}</BodyCopy>}
        </Copy>
        <CTAs>
            {!!props.buttonPrimary.text && <Button variant={props.buttonPrimary.variant} type={'action'} disabled={props.buttonPrimary.disabled} action={!!props.buttonPrimary.action ? props.buttonPrimary.action : () => props.displayModal(false)} text={props.buttonPrimary.text} handleClick={props.buttonPrimary.handleClick} operation={props.buttonPrimary.operation} processing={props.buttonPrimary.processing} />}
            {!!props.buttonSecondary.text && <Button variant={props.buttonSecondary.variant} type={'action'} disabled={props.buttonSecondary.disabled} action={!!props.buttonSecondary.action ? props.buttonSecondary.action : () => props.displayModal(false)} text={props.buttonSecondary.text} handleClick={props.buttonSecondary.handleClick} operation={props.buttonSecondary.operation} processing={props.buttonSecondary.processing} />}
        </CTAs>
    </SubPage>
);



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
// will be utilized in parent component after being infused with app state & actions
export default injectSheet(styles)(PopupMessage);